import { Navigate, Outlet } from "react-router-dom";

import { PATHS } from "../../../app/router/paths";
import { useAuth } from "../model/AuthContext";

export const RequirePermission = ({ permission }: { permission: string }) => {
  const { user } = useAuth();
  return user?.permissions.includes(permission) ? <Outlet /> : <Navigate to={PATHS.AUTH.FORBIDDEN} replace />;
};
